<template>
  <div class="">
    <b-overlay :show="showSplash" rounded="sm">
      <template #overlay> </template>
      <b-container fluid>
        <b-row class="text-white" style="color: white">
          <b-col class="m-0 p-0">
            <div class="text-center w-full w-100">
              <!-- {{ goingTo }} -->
              <div class="points-div"></div>
              <!-- {{ retrievedStore }} -->

              <img src="@/assets/splash.png" class="splash-view trophy-image" />
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-overlay>
  </div>
</template>

<script>
// import store from "@/store";
import { mapState, mapActions } from "vuex";
import { Capacitor } from "@capacitor/core";
import { Preferences } from "@capacitor/preferences";
import { App } from "@capacitor/app";
import store from "@/store";

export default {
  data() {
    return {
      curD: new Date(),
      countdown: 5,
      showSplash: false,
      retrievedStore: {},
      goingTo: "",
      timeToGo: null,
      delayInLeaving: null
    };
  },

  beforeRouteEnter(to, from, next) {
    store.dispatch("loginmaster/setOrigin");

    if (!store.state.dashboard.appLandingVisited) {
      next(vm => {
        if (Capacitor.isNativePlatform()) {
          vm.getAppStateMobile();
          // vm.updateDetails();
        }
      });

      next();
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeToGo);
    clearTimeout(this.delayInLeaving);
  },
  beforeRouteLeave(to, from, next) {
    clearTimeout(this.timeToGo);
    clearInterval(this.delayInLeaving);
    next(vm => {
      vm.updateDetails();
    });
    next();
    //NProgress.done();
  },
  async mounted() {
    this.$store.dispatch("setNativePlatform", Capacitor.isNativePlatform());
    const appInfo = Capacitor.isNativePlatform() ? await App.getInfo() : {};
    this.$store.dispatch(
      "setAppVersion",
      Capacitor.isNativePlatform()
        ? appInfo.version
        : process.env.VUE_APP_CURRENT_VERSION
    );

    if (Capacitor.isNativePlatform()) {
      this.getAppStateMobile();

      this.timeToGo = setTimeout(() => {
        if (this.goingTo != "/" || this.goingTo != "") {
          this.$router.push(this.goingTo);
        } else {
          if (this.$store.state.loginmaster.details.category == "Individual") {
            this.goingTo = "/dashboard";
            this.setAppVisit();
            this.$router
              .push({
                path: this.goingTo
              })
              .catch(() => true);
          } else if (
            this.$store.state.loginmaster.details.category == "Organization"
          ) {
            this.goingTo = "/orgadmin";
            this.setAppVisit();
            this.$router
              .push({
                path: this.goingTo
              })
              .catch(() => true);
          }
        }

        this.setAppVisit();
      }, 4000);
    } else {
      this.setAppVisit();
      this.$router.push("/login");
    }

    this.delayInLeaving = setInterval(() => {
      this.setAppVisit();

      if (this.$route.path == "/" || this.$route.path == "") {
        this.$router.push("/login");
      } else {
        clearInterval(this.delayInLeaving);
      }
    }, 5000);

    // this.updateDetails();
  },
  created() {},

  methods: {
    ...mapActions("loginmaster", ["sendLogin"]),
    ...mapActions("loginmaster", ["updateDetails"]),
    ...mapActions("dashboard", ["setAppVisit"]),

    chkTrial() {
      if (this.trial <= 0 && this.plan != "Premium") {
        return true;
      }
    },

    async saveAppStateMobile(storeState) {
      await Preferences.set({
        key: "store",
        value: JSON.stringify(storeState)
      });
    },

    async getAppStateMobile() {
      try {
        const ret = await Preferences.get({ key: "store" });
        const savedStore = JSON.parse(ret.value);

        const originalStore = store.state;
        const newStore = {
          ...originalStore,
          ...savedStore
        };

        this.retrievedStore = newStore;

        store.replaceState(newStore);

        if (newStore.loginmaster.loggedIn) {
          store.watch(
            state => {
              return state;
            },
            async newState => {
              const newObj = { ...newState };
              delete newObj.admin;
              delete newObj.dashboard;

              // console.log(newObj, "Pre Saving");
              await Preferences.set({
                key: "store",
                value: JSON.stringify(newObj)
              });
            },
            { immediate: true }
          );

          store.subscribe(async (mutation, state) => {
            const newObj = { ...state };
            delete newObj.admin;
            delete newObj.dashboard;

            // console.log(newObj, "Pre Saving");
            await Preferences.set({
              key: "store",
              value: JSON.stringify(newObj)
            });
          });

          // this.updateDetails();
          if (newStore.loginmaster.details.category == "Individual") {
            this.goingTo = newStore.loginmaster.lastVisitedRoute
              ? newStore.loginmaster.lastVisitedRoute == "/"
                ? "/dashboard"
                : newStore.loginmaster.lastVisitedRoute
              : "/dashboard";
            this.setAppVisit();
            this.$router
              .push({
                path: newStore.loginmaster.lastVisitedRoute
                  ? newStore.loginmaster.lastVisitedRoute == "/"
                    ? "/dashboard"
                    : newStore.loginmaster.lastVisitedRoute
                  : "/dashboard"
              })
              .catch(() => true);
          } else if (newStore.loginmaster.details.category == "Organization") {
            this.goingTo = newStore.loginmaster.lastVisitedRoute
              ? newStore.loginmaster.lastVisitedRoute == "/"
                ? "/orgadmin"
                : newStore.loginmaster.lastVisitedRoute
              : "/orgadmin";
            this.setAppVisit();
            this.$router
              .push({
                path: newStore.loginmaster.lastVisitedRoute
                  ? newStore.loginmaster.lastVisitedRoute == "/"
                    ? "/orgadmin"
                    : newStore.loginmaster.lastVisitedRoute
                  : "/orgadmin"
              })
              .catch(() => true);
          }
        } else {
          this.setAppVisit();
          this.goingTo = "Login";
          this.$router.push("/login").catch(() => true);
        }
      } catch (error) {
        this.setAppVisit();
        this.goingTo = "Login2";
        this.$router.push("/login").catch(() => true);
      }
    }
  },
  computed: {
    ...mapState({
      fullname: state => state.loginmaster.details.fullname,
      details: state => state.loginmaster.details,
      loggedin: state => state.loginmaster.loggedIn,
      plan: state => state.loginmaster.details.plan,
      trial: state => state.loginmaster.trial,
      clearance: state => state.loginmaster.details.clearance,
      level: state => state.loginmaster.details.clearance_level,
      ongoing: state => state.ongoing,
      start_config: state => state.exam.start_config
    })
  }
};
</script>

<style scoped>
.actbtnblue {
  background-color: #00377b;
}

.actbtnblue:hover {
  background-color: rgba(5, 32, 112, 0.809);
}

.splash-view {
  width: 100%;
  height: 100vh;
}

.landprem {
  font-size: 1rem;
}

.welcland {
  font-size: 2.3rem;
  font-weight: bold;
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif;
}

.actbtn {
  font-weight: bold;
  font-size: 20px;
}

.ypu {
  font-size: 0.8rem;
}

.selact {
  font-size: 1.3rem;
  font-weight: bold;
}
.imgwelc {
  width: 100%;
}

@media (max-width: 768px) {
  .welclandh {
    font-size: 1.2rem !important;
  }
  .imgwelc {
    width: 75%;
  }
}
</style>
